import { Pipe, PipeTransform } from '@angular/core';
import { ReportCategory } from "@app/cp/shared/static/reports.config";
import { PriorityStatus } from "@app/cp/shared/models/PriorityStatus.interface";

@Pipe({
    name: 'PriorityStatus',
    standalone: true,
    pure: true
})
export class PriorityStatusPipe implements PipeTransform {

    transform(status: string): string {
        // Return class names based on input
        return status === 'active' ? 'priority-disabled' : '';
    }

}
